import React from "react";
import { Route, RouteProps, Redirect } from "react-router-dom";
import { setError } from "../features/login/LoginSlice";
import { useDispatch } from "../redux/hooks";

interface PrivateRouteProps extends RouteProps {
  component: React.ComponentType<any>;
}
//トークンから有効時間をチェックする
const checkTokenExist = () => {
  const token = sessionStorage.getItem("token");
  if (!token) {
    //トークンがなかったらnull
    return false;
  }
  if (token) {
    return true;
  }
};

export const PrivateRoute: React.FC<PrivateRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const isTokenExpired = checkTokenExist();
  const dispatch = useDispatch();
  return (
    <Route
      {...rest}
      render={(props) => {
        //トークン有効
        if (isTokenExpired === true) {
          return <Component {...props} />;
        } else if (isTokenExpired === false) {
          dispatch(setError("ログインしてください"));
          //トークンがない
          return <Redirect to="/Login" />;
        }
        // else {
        //   alert("タイムアウトしました");
        //   sessionStorage.clear();
        //   window.location.href = "/login";
        // }
      }}
    />
  );
};
